import moment, { Moment } from 'moment';
import _ from 'lodash';

import { get, post } from './commonFetch';
import {
  WaiverWorkItem,
  WaiverWorkItemDetailsResponse,
  WaiverWorkItemSearchCriteria,
} from '../types/waiverWorkItem';

function transform(waiverWorkItem: any): WaiverWorkItem {
  return {
    ...waiverWorkItem,
    updatedAt: waiverWorkItem.updatedAt && moment(waiverWorkItem.updatedAt),
    createdAt: waiverWorkItem.createdAt && moment(waiverWorkItem.createdAt),
    lastAlertedAt:
      waiverWorkItem.lastAlertedAt && moment(waiverWorkItem.lastAlertedAt),
    associatedWaiverIds: new Set(waiverWorkItem.associatedWaiverIds || []),
  };
}

function serialize(waiverWorkItem: WaiverWorkItem): any {
  return {
    ...waiverWorkItem,
    associatedWaiverIds: waiverWorkItem.associatedWaiverIds && [
      ...(Array.from(waiverWorkItem.associatedWaiverIds) || []),
    ],
  };
}

function transformSearchCriteria(
  searchCriteria: WaiverWorkItemSearchCriteria,
): any {
  if (!searchCriteria.dateRange) {
    return searchCriteria;
  }

  const startDate: Moment | undefined = searchCriteria.dateRange.startDate;
  const endDate: Moment | undefined = searchCriteria.dateRange.endDate;

  return Object.assign(
    _.omit(searchCriteria, 'dateRange'),
    startDate ? { createdStartDate: startDate.format('YYYY-MM-DD') } : null,
    endDate ? { createdEndDate: endDate.format('YYYY-MM-DD') } : null,
  );
}

export function getWaiverWorkItems(
  waiverSearchQuery: WaiverWorkItemSearchCriteria,
): Promise<WaiverWorkItem[]> {
  return get(
    '/api/waiverWorkItems',
    transformSearchCriteria(waiverSearchQuery),
  ).then((response) => (response as WaiverWorkItem[]).map(transform));
}

export function getWaiverWorkItemDetails(
  workItemId: number,
): Promise<WaiverWorkItemDetailsResponse> {
  return get(`/api/waiverWorkItemDetails/${workItemId}`).then((response: any) => ({
    workItemDetails: {
      ...(typeof response === 'object' ? response : {}),
      workItemId,
    },
    workItem: transform(response.workItem),
  }));
}

export function upsertWaiverWorkItem(
  waiverWorkItem: WaiverWorkItem,
): Promise<WaiverWorkItem> {
  return post(
    '/api/waiverWorkItems',
    serialize(waiverWorkItem),
  ).then(response => transform(response));
}
